import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import CampaignListScreen from "../screens/CampaignListScreen";
import CampaignScreen from "../screens/CampaignScreen";

type CampaignsRouterProps = RouteComponentProps;

const CampaignsRouter: React.FC<CampaignsRouterProps> = ({
  match,
}) => (
  <Switch>
    <Route
      path={`${match.path}/:id`}
      exact
      component={CampaignScreen}
    />
    <Route
      path={`${match.path}`}
      exact
      component={CampaignListScreen}
    />
  </Switch>
);

export default CampaignsRouter;
